/**
 * Typed error codes thrown as `ConvexError({ code })` by game mutations. Prod Convex hides
 * plain `Error` messages from clients, so the app matches on these codes instead.
 */

/** Thrown by `acceptMidTableRebuy` when the player has used every rebuy the game allows. */
export const REBUY_LIMIT_REACHED_ERROR_CODE = 'REBUY_LIMIT_REACHED'
